var jquery = require("jquery");
window.$ = window.jQuery = jquery;
var visible = require("jquery-visible");

require('lazysizes');
window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.preloadAfterLoad = true;

require("@fancyapps/fancybox");
import Rellax from 'rellax';
import Swiper from 'swiper/bundle';
import ScrollOut from "scroll-out";

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);
window.addEventListener('resize', () => {
	// We execute the same script as before
	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);
});

var rellax = new Rellax('.rellax', {
});

ScrollOut({
	targets: [
		"[data-scroll]",
		"[data-fade]",
	],
	threshhold: 0.5,
	offset: 0,
	cssProps: { 
	   visibleY: true,
	   viewportY: true,
	} 
})

var lastST = 0;
var delta = 5;
var navbarHeight = $('.headerContainer').outerHeight();
var counterDone = new Array();
var dropsWithMenu = $('.page-nav-section').add('.section-filters');

// READY

$(function () {

	console.log('Website proudly by Imagic Creative');

	$("[data-required]").each(function (index) {
		$(this).attr('required', true);
	});

	btnIntoView();

	if ($('.submenu .a-link.active').length) {
		$('.submenu .a-link.active').parent().parent().find('a').first().addClass('active');
	}

    
	$('main').addClass('loaded');
	$('main').removeAttr('style');

	menuDrop();

	filterBg();

	pageNav();

	if ($('.counter').length && $('.counter').visible(true)) {
		counters();
	}

	if ($('.slider-cards').length) {
		sliderCardsButtons($('.slider-cards'));
	}

	if ($('.marquee').length) {
		var marquee = $('.marquee');
		marquee.each(function() {
			loop($(this));
		});
		
		function loop(marquee){
			var start = (marquee.find('.flex').first().outerWidth() / $(window).width()) * 100 * (-1);
			var speed = marquee.data('speed') * 1000;
			// console.log(start);
			$({circle:0}).animate({circle: start}, {
				duration: speed, 
				easing: "linear",
				step: function(val) {
					marquee.css('transform', 'translate3d(' + val + '%, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)');
				},
				complete: function() {
					loop(marquee);
				}
			});
		}
	}

	if ($('.accordion').length) {
		const accordionBtns = document.querySelectorAll(".accordion");
		if (accordionBtns.length){
			accordionBtns.forEach((accordion) => {     	
				accordion.onclick = function () {
					// this.classList.add("is-open");
					let content = this.nextElementSibling;
					$(this).toggleClass('is-open');
					if ($(this).hasClass('is-open')) {
						content.style.maxHeight = content.scrollHeight + "px";
						// if ($('.accordion-section.accordion-dark').length) {
						// 	window.location.hash = $(this).attr('id').replace('accordion','accordion-target');
						// }
					} else {
						content.style.maxHeight = null;	
						// if ($('.accordion-section.accordion-dark').length) {
						// 	window.location.hash = false;
						// }
					}
					
					setTimeout(() => {
						rellax.refresh();
					}, 1300);

				};
			});    
		}
	}
	
	setTimeout(() => {
		if (typeof rellax.refresh === 'function') {
			rellax.refresh();
		}
	}, 1300);

});


// SCROLL

$(window).on('scroll', function(e) {

	menuDrop();

	filterBg();

	pageNav();

	if ($('.counter').length && $('.counter').visible(true)) {
		counters();
	}

});


$('.page-nav-section-row').on('scroll', function(e) {
	subnavArrow();
});



// RESIZE

$(window).on('resize maximized', function() {

	filterBg();

	pageNav();

	btnIntoView();

});


// SLIDERS 

if ($('.slider-projects').length) {
	const sliderP = new Swiper('.slider-projects', {
		slidesPerView: 1,
		spaceBetween: 16,
		autoResize: false,
		loop: false,
		normalizeSlideIndex: true,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		speed: 400,
		autoplay: false,
		hashNavigation: false,
		touchEventsTarget: 'wrapper',
        breakpoints: {
            1024: {
                slidesPerView: 1.2,
            },
            1280: {
                slidesPerView: 1.2,
            },
            1696: {
                slidesPerView: 1.3,
            },
        }
	});
}
if ($('.slider-projects-smaller').length) {
	const sliderP = new Swiper('.slider-projects-smaller', {
		slidesPerView: 1,
		spaceBetween: 16,
		autoResize: false,
		loop: false,
		normalizeSlideIndex: true,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		speed: 400,
		autoplay: false,
		hashNavigation: false,
		touchEventsTarget: 'wrapper',
        breakpoints: {
            768: {
                slidesPerView: 1.5,
            },
            1024: {
                slidesPerView: 2.1,
            },
            1280: {
                slidesPerView: 2.5,
            },
        }
	});
}
if ($('.slider-cards').length) {
	const sliderP = new Swiper('.slider-cards', {
		slidesPerView: 1.1,
		spaceBetween: 16,
		autoResize: false,
		loop: true,
		centeredSlides: true,
		normalizeSlideIndex: true,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		speed: 400,
		autoplay: false,
		hashNavigation: false,
		touchEventsTarget: 'wrapper',
        breakpoints: {
            640: {
                slidesPerView: 1.3,
				spaceBetween: 80,
            },
            768: {
                slidesPerView: 1.5,
				spaceBetween: 80,
            },
            1024: {
                slidesPerView: 1.8,
				spaceBetween: 100,
            },
            1280: {
                slidesPerView: 2.5,
				spaceBetween: 100,
            },
            1696: {
                slidesPerView: 3,
				spaceBetween: 172,
            },
        }
	}).on('beforeTransitionStart', function(swiper) {
		$(swiper.el).addClass('swiper-transitioning');
	}).on('transitionEnd', function(swiper) {
		$(swiper.el).removeClass('swiper-transitioning');
	}).on('resize', function(swiper) {
		sliderCardsButtons($(swiper.el));
	});
}

function sliderCardsButtons(swiperEl) {
	if ($(window).width() >= 640) {
		var btnRow = swiperEl.find('.buttons-row');
		var btnPrev = btnRow.find('.swiper-button-prev');
		var btnNext = btnRow.find('.swiper-button-next');
		var btnW = btnPrev.outerWidth();
		var btnRowLeft = btnRow.offset().left;
		var btnRowRight = btnRowLeft + btnRow.outerWidth();
		var slide = swiperEl.find('.swiper-slide-active');
		var slideLeft = slide.offset().left;
		var slideRight = slideLeft + slide.outerWidth();
		var coeff = (slide.css('margin-right').replace('px','') - btnW) / 2;
		var left = slideLeft - btnRowLeft - btnW - coeff;
		var right = btnRowRight - slideRight - btnW - coeff;
		btnPrev.css('left', left);
		btnNext.css('right', right);
	}
}

if ($('.slider-videos').length) {
	const sliderV = new Swiper('.slider-videos', {
		slidesPerView: 1,
		spaceBetween: 16,
		autoResize: false,
		loop: false,
		normalizeSlideIndex: true,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		speed: 400,
		autoplay: false,
		hashNavigation: false,
		touchEventsTarget: 'wrapper',
        breakpoints: {
            640: {
                slidesPerView: 1.2,
            },
            768: {
                slidesPerView: 1.6,
            },
            1024: {
                slidesPerView: 2.1,
            },
            1280: {
                slidesPerView: 2.5,
            },
            1696: {
                slidesPerView: 3,
            },
        }
	});
}

if ($('.slider-articles').length) {
	const sliderA = new Swiper('.slider-articles', {
		slidesPerView: 1,
		spaceBetween: 16,
		autoResize: false,
		loop: false,
		normalizeSlideIndex: true,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		speed: 400,
		autoplay: false,
		hashNavigation: false,
		touchEventsTarget: 'wrapper',
        breakpoints: {
            640: {
                slidesPerView: 1.2,
            },
            768: {
                slidesPerView: 1.6,
            },
            1024: {
                slidesPerView: 2.1,
            },
            1280: {
                slidesPerView: 2.5,
            },
            1696: {
                slidesPerView: 3,
            },
        }
	});
}


if ($('.team-section').length) {
	var teams = $('.team-section');
	teams.each(function() {
		const sliderT = new Swiper($(this).find('.slider-team')[0], {
			slidesPerView: 1,
			spaceBetween: 16,
			autoResize: false,
			loop: false,
			normalizeSlideIndex: true,
			navigation: {
				nextEl: $(this).find('.swiper-button-next')[0],
				prevEl: $(this).find('.swiper-button-prev')[0],
			},
			speed: 400,
			autoplay: false,
			hashNavigation: false,
			touchEventsTarget: 'wrapper',
			breakpoints: {
				480: {
					slidesPerView: 1.3,
				},
				640: {
					slidesPerView: 1.6,
				},
				768: {
					slidesPerView: 2,
				},
				1024: {
					slidesPerView: 2.5,
				},
				1280: {
					slidesPerView: 3,
				},
				1696: {
					slidesPerView: 4,
				},
			}
		});
	});
}



// FILTERS

$(document).on('click', '#load-more-btn', function(e) {
	$(this).find('.loader').removeClass('hidden').addClass('block');
});



$(document).on('click', '[data-fancybox]', function(e) {
	var headerEl = $('header');
	headerEl.addClass('nav-up').removeClass('nav-down');
	dropsWithMenu.removeClass('nav-down');
});



// FUNCTIONS

function counters() {
	$('.counter').each(function(i) {
		var el = $(this);
		if ($(this).visible(true) && !counterDone[i]) {
			$({ Counter: 0 }).animate({
				Counter: el.text()
			}, {
				duration: 1000,
				easing: 'swing',
				step: function() {
					if (el.data('type') == 'float') {
						var decimals = el.data('decimals');
						el.text((this.Counter).toFixed(decimals));	
					} else {
						el.text(Math.ceil(this.Counter));
					}
				}
			});
			counterDone[i] = true;
		}
	});
}


function btnIntoView() {
	if ($('.page-nav-btn.active').length) {
		var allBtns = $('.page-nav-section-row').children();
		var allW = 70;
		allBtns.each(function() {
			allW = allW + $(this).outerWidth();
		});
		if ($(window).width() < allW) {
			$('.page-nav-section').addClass('has-scroll');
			$(".page-nav-btn.active")[0].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
		} else {
			$('.page-nav-section').removeClass('has-scroll');
		}
		subnavArrow();
		// console.log($(window).width() + ' < ' + allW);
	}
}

function subnavArrow() {
	if ($('.page-nav-section-row .page-nav-btn').last().visible()) {
		$('.page-nav-section-overlay').removeClass('has-more');
	} else {
		$('.page-nav-section-overlay').addClass('has-more');
	}
}



function menuDrop() {

	var headerEl = $('header');
    var st = $(window).scrollTop();

	if ($('body.sector-category').length || $('body.service-category').length) {
		return false;
	}

    // Make sure they scroll more than delta
    if (Math.abs(lastST - st) <= delta)
        return;
    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.

    if (st > lastST && st > navbarHeight ) {
        // Scroll Down
		// console.log('Scroll Down');
        if (headerEl.hasClass('nav-down')) {
            headerEl.removeClass('nav-down').addClass('nav-up');
            dropsWithMenu.removeClass('nav-down').addClass('nav-up');
			// $('.nav-btn').removeClass('nav-down');
        } else {
			headerEl.addClass('nav-up');
			dropsWithMenu.addClass('nav-up');
		}
    } else {
        // Scroll Up
		// console.log('Scroll Up');
        if (st > navbarHeight && (st + $(window).height() < $(document).height())) {
			headerEl.addClass('header-fixed');
            headerEl.removeClass('nav-up').addClass('nav-down');
            dropsWithMenu.removeClass('nav-up').addClass('nav-down');
			// $('.nav-btn').addClass('nav-down');
        } 

        if (st < 20) {
            headerEl.removeClass('nav-up').removeClass('nav-down').removeClass('header-fixed');
            dropsWithMenu.removeClass('nav-up').removeClass('nav-down').removeClass('header-fixed');
			// $('.nav-btn').removeClass('nav-down');
        }

    }
    
    lastST = st;
} 


function filterBg() {
	var filter = $('.filters');
	if (filter.length) {
		var filterTop = filter.offset().top;
		var diff = filterTop - $(window).scrollTop();
		if (diff == 0) {
			filter.addClass('bg-grey');
		} else {
			filter.removeClass('bg-grey');
		}
	}
}

function pageNav() {
	var nav = $('.page-nav-section');
	if (nav.length) {
		var navTop = nav.offset().top;
		var diff = navTop - $(window).scrollTop();
		if (diff == 0) {
			nav.addClass('is-stuck');
		} else {
			nav.removeClass('is-stuck');
		}
	}
}



// OBSERVERS VARS

var list = [];
for (var i = 0; i <= 100; i++) {
    list.push(i / 100);
}
const config = {
	threshold: list
};



// MOBILE MENU


$('div[data-target-submenu]').on("click", function(e) {
    $('.toplevel').css('transform','translateX(-100%)');
    $('.submenu').css('transform','translateX(-100%)');
    var targetsubmenu = $(this).data('target-submenu');
    $('[data-submenu]').hide();
    $('[data-submenu="' + targetsubmenu + '"]').show();
});

$('.back').on("click", function(e) {
    $('.toplevel').css('transform','translateX(0%)');
    $('.submenu').css('transform','translateX(0%)');
});

$('.asideMenuTrigger').on("click", function(e) {
	showAside($(this), $(this).attr('data-trigger'));
	e.stopPropagation();
    e.preventDefault();
});

$('main').add('footer').on("click", function(e) {
	if ($('aside.mobileMenu.menuOpened').length) {
		showAside($('.asideMenuTrigger'), $('.asideMenuTrigger').attr('data-trigger'));
	}
});

function showAside(trigger, asideElement) {
	trigger.toggleClass('closed');
	trigger.toggleClass('opened');
	$('body').toggleClass('menuOpened');
	$('aside.mobile'+asideElement).toggleClass('menuOpened');
    var substractHeights = $('.headerContainer').outerHeight();
    var menuContainerHeight = "calc(100vh - " + substractHeights + "px)";
    $('.megaMenuContainer').css("height", menuContainerHeight);
	trigger.find('.hamburger').toggleClass('is-active');

	var activeLink = $('aside .megaSubmenuDropdown .active');
	if (activeLink.length) {
		var menu = activeLink.closest('.megaSubmenuDropdown').data('submenu');
		var menuHeading = $('[data-target-submenu="' + menu + '"]');
		menuHeading.trigger('click');
	}
}



// PROJECTS FILTERS

$(document).on('click', '#projectFilter .filter', function(e) {
	var target = $(this).data('target');
	var targetEl = $('#projectFilter .options[data-filter="' + target + '"]');
	$('#projectFilter .options').addClass('animate');
	$('#projectFilter .options').not(targetEl).removeClass('active');
	$('#projectFilter .options').not(targetEl).css('height', 0);
	if (targetEl.hasClass('active')) {
		targetEl.removeClass('active');
		targetEl.css('height', 0);
		$('.filter-clear.clear-all').removeClass('hide');
	} else {
		targetEl.addClass('active');
		var totalHeight = 0;
		targetEl.children().each(function(){
			if($(this).css('display') != 'none'){
				totalHeight = totalHeight + $(this).outerHeight(true);
			}
		});
        var maxH = $(window).height() - $('section.section-filters').outerHeight();
        if (totalHeight >= maxH) {
            totalHeight = maxH;
        }
		targetEl.css('height', totalHeight);
		$('.filter-clear.clear-all').addClass('hide');
	}
	
	$('#projectFilter .filter').not($(this)).removeClass('open');
	$(this).toggleClass('open');
});

$(document).on('click', '#projectFilter .filter-buttons button', function(e) {
	$(this).toggleClass('active');
	var filter = $(this).parent().parent().data('filter');
	$('.filter[data-target="' + filter + '"] svg.chevron').hide();
	$('.filter[data-target="' + filter + '"] .loader').show();
});

$(document).on('click', '.filter-clear.clear-all', function(e) {
	$('.filter.active svg.chevron').hide();
	$('.filter.active .loader').show();
});

$(document).on("click", function(event) {
	if ($(event.target).closest("#projectFilter .filter").length === 0 && $(event.target).closest("#projectFilter .options").length === 0) {
		$('#projectFilter .options').removeClass('active');
		$('#projectFilter .options').css('height', 0);
		$('#projectFilter .filter').removeClass('open');
        $('.filter-clear.clear-all').removeClass('hide');
	}
});